// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"106":"e2f66cc3","286":"352d109d","772":"69846bd9"}[chunkId] + ".css";
};